<template>
    <div class="botOptions">
        <div class="content pagination" v-if="pages.length > 1">
            <div class="page" @click="prev">
                <svg><use xlink:href="#icon-arrow"></use></svg>
            </div>
<!--            <div class="page" v-for="(p,key) in pages" v-if="pages.length > 1 && (p < 3 || (p > pages.length - 3) || (p < current + 3 && p > current - 3))" @click="$emit('change',key)" :class="{'active':current === p}">-->
<!--                <span>{{p+1}}</span>-->
<!--            </div>-->
<!--            <div v-else-if="(p === 4 && current > 4) || (p === pages.length - 4 && current < pages.length - 4)">-->
<!--                ...-->
<!--            </div>-->
            <div class="page" v-for="(p,key) in pages" @click="changePage(p)" :class="{'active':current === p - 1}">
                {{p}}
            </div>
            <div class="page" @click="next">
                <svg><use xlink:href="#icon-arrow"></use></svg>
            </div>
        </div>
        <div class="content selectShow">
            <span>Résultat : {{array.length}} </span>

        </div>
        <div class="content selectShow">
            <span>Affichage : </span>
            <select v-model="currentLimit" @change="changeLimit">
                <option v-for="(l) in arrayLimit">{{l}}</option>
            </select>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Pagination",
        props : {
            array:"",
            current:0,
            limit:0,
        },
        data(){
            return{
                pages:[],
                arrayLimit : [10,25,50,100,200,500],
                currentLimit : 0,
            }
        },
        methods:{
            prev(){
                if(this.current <= 0){
                    return false;
                }
                this.$emit("change",this.current-1)
            },
            next(){
                if(this.current >= this.pages.length - 1){
                    return false;
                }
                this.$emit("change",this.current+1)
            },
            changePage(p){
                if(p === "...") return;

                this.$emit('change',p-1);
            },
            changeLimit(){
                this.$emit('limitChange',this.currentLimit)
            },
            loadPage(){

                this.pages = [];
                let nbPage = Math.ceil(this.array.length / this.limit);
                for(let i = 0; i < nbPage; i++) {
                    let p = i;
                    if(nbPage > 1 && (p < 3 || (p > nbPage - 3) || (p < this.current + 3 && p > this.current - 3))){
                        this.pages.push(p + 1)
                    }else if((p === 4 && this.current > 4) || (p === nbPage - 4 && this.current < nbPage - 4)){
                        this.pages.push("...")
                    }
                }
            }
        },
        watch:{
            array(){
                if(this.limit <= 0){
                    return;
                }

                this.loadPage();
            },
            limit(){
                if(this.limit <= 0){
                    return;
                }

                this.currentLimit = this.limit;

                this.loadPage();
            },
            current(){
                this.loadPage();
            }
        },
        mounted(){

            this.currentLimit = this.limit

        }
    }
</script>